module.exports = __webpack_public_path__ + "img/poggi.653b7026.png";